module.exports = require('./bundle-url').getBundleURL() + "plockledemo1.3daedbc0.jpg"